// StyleUp extras — variant-scoped gallery + first-accordion-open
(function(){
  'use strict';
  
  // 1) First accordion default-open on PDP
  function openFirstAccordion() {
    if (!document.body.classList.contains('template-product')) return;
    var details = document.querySelectorAll('product-info details, .product__info-wrapper details, .product__description details');
    if (details.length && !details[0].open) details[0].open = true;
  }
  document.addEventListener('DOMContentLoaded', openFirstAccordion);
  if (document.readyState !== 'loading') openFirstAccordion();
  
  // 2) Variant-scoped gallery: hide media not associated with current variant
  function filterGalleryByVariant() {
    // Detect PDP by URL (body.classList doesn't include template-product reliably)
    if (location.pathname.indexOf('/products/') !== 0) return;
    if (!window.__SU_VARIANT_MEDIA) return;
    // Find currently selected variant id — try hidden input first, then variant-radios
    var variantInput = document.querySelector('input[name="id"]:checked') || 
                       document.querySelector('select[name="id"]') ||
                       document.querySelector('variant-radios input[name="id"]') ||
                       document.querySelector('input[name="id"]');
    if (!variantInput) return;
    var variantId = variantInput.value;
    var allowed = window.__SU_VARIANT_MEDIA[variantId] || [];
    if (!allowed.length) {
      // No mapping — show everything
      document.querySelectorAll('[data-media-id]').forEach(function(el){ el.style.display = ''; });
      return;
    }
    document.querySelectorAll('[data-media-id]').forEach(function(el){
      var _limg = (el.tagName === 'IMG') ? el : (el.querySelector ? el.querySelector('img') : null);
      if (_limg && document.querySelector('.su-pdp') && /sizechart/i.test((_limg.getAttribute('src')||'')+' '+(_limg.currentSrc||'')+' '+(_limg.src||''))) { el.style.display = 'none'; return; }
      if (_limg && /\bworn\b/i.test(_limg.getAttribute('alt') || '')) { el.style.display = ''; return; }
      var raw = String(el.dataset.mediaId || '');
      // Media IDs come either as bare "28165787975765" or prefixed "template--ID__main-28165787975765"
      var match = raw.match(/(\d+)$/);
      var mid = match ? match[1] : raw;
      var show = allowed.indexOf(mid) !== -1;
      // Don't override existing slider hide state for non-active slides on LIs that are slider slides
      if (el.tagName === 'LI' && el.classList.contains('slider__slide') && !el.classList.contains('is-active') && !show) {
        return; // leave alone
      }
      el.style.display = show ? '' : 'none';
    });
  }
  
  // Listen to variant change events
  document.addEventListener('change', function(e){
    if (e.target && (e.target.name === 'id' || e.target.closest('variant-radios') || e.target.closest('variant-selects'))) {
      setTimeout(filterGalleryByVariant, 200);
    }
  });
  document.addEventListener('variant:change', filterGalleryByVariant);
  setTimeout(filterGalleryByVariant, 500);
  setTimeout(filterGalleryByVariant, 1500); // re-run after Shopify hydrates
  
  // 3) Inject "Size guide" + "True to size" links if missing (resilient against Spotlight markup changes)
  function enhanceVariantPicker() {
    if (!document.body.classList.contains('template-product')) return;
    var sizePicker = document.querySelector('variant-radios fieldset:nth-of-type(2), .product-form__input--pill, .variant-picker__option--size');
    if (!sizePicker || sizePicker.querySelector('.su-size-guide-link')) return;
    var link = document.createElement('a');
    link.className = 'su-size-guide-link';
    link.href = '/pages/size-guide';
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'Size guide ↗';
    link.style.cssText = 'display:inline-block;margin-left:auto;font-size:13px;color:var(--su-signal,#E54B2A);text-decoration:underline;float:right;';
    var legend = sizePicker.querySelector('legend');
    if (legend) legend.appendChild(link);
  }
  document.addEventListener('DOMContentLoaded', enhanceVariantPicker);
  if (document.readyState !== 'loading') enhanceVariantPicker();
})();




// =========================================================
// SU_SMART_NUDGES v2 — combo (₹1,499) restricted to Oversized line.
//   - Checks each cart item's product_type and the current PDP's product type
//   - Combo nudge only fires for "Oversized Tees" context
//   - Supima PDPs: no combo nudge (would be misleading)
// =========================================================
(function(){
  if (typeof document === 'undefined') return;
  var OVERSIZED_TYPE = 'Oversized Tees';
  var SAVINGS_LINE = 'Buy 2 Spirit Animal tees at ₹1,499 — save ₹99.';
  
  function isCartPage()    { return location.pathname.indexOf('/cart') === 0; }
  function isProductPage() { return location.pathname.indexOf('/products/') === 0; }
  
  function pill(text, tone) {
    var bg = tone === 'win'  ? '#C9F2DC' : (tone === 'tease' ? '#FFF8DC' : '#F2EEE5');
    var bd = tone === 'win'  ? '#0F0F12' : (tone === 'tease' ? '#D4A300' : '#6B6B6B');
    var el = document.createElement('div');
    el.className = 'su-combo-nudge';
    var _bmw=(document.querySelector('.product-form__buttons')?getComputedStyle(document.querySelector('.product-form__buttons')).maxWidth:'');
    el.style.cssText = 'margin:14px 0;padding:12px 16px;background:'+bg+';border:1px dashed '+bd+';border-radius:6px;font-size:14px;font-weight:600;text-align:center;color:#0F0F12;box-sizing:border-box;'+((_bmw&&_bmw!=='none')?'max-width:'+_bmw+';':'');
    el.textContent = text;
    return el;
  }
  
  function currentProductType() {
    // Expose via __SU_CURRENT_PRODUCT_TYPE set in product page or detect via DOM
    if (window.__SU_CURRENT_PRODUCT_TYPE) return window.__SU_CURRENT_PRODUCT_TYPE;
    // Fallback: detect from product handle pattern
    var path = location.pathname;
    if (/\/products\/unisex-oversized-classic-t-shirt-/.test(path)) return 'Oversized Tees';
    return null;
  }
  
  function countOversizedInCart(cart) {
    return (cart.items || []).reduce(function(n, it){
      return n + (it.product_type === OVERSIZED_TYPE ? it.quantity : 0);
    }, 0);
  }
  
  function renderNudge() {
    document.querySelectorAll('.su-combo-nudge, .su-welcome-cue').forEach(function(n){ n.remove(); });
    fetch('/cart.js', { credentials: 'include' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var oversizedQty = countOversizedInCart(c);
        
        if (isCartPage()) {
          // Only nudge when exactly ONE oversized item is in cart (1 more needed to unlock)
          if (oversizedQty !== 1) return;
          var host = document.querySelector('cart-items .page-width') || document.querySelector('cart-items') || document.querySelector('form#cart');
          if (!host) return;
          host.insertAdjacentElement('afterbegin', pill('✨ Add 1 more Spirit Animal tee — unlock ' + SAVINGS_LINE, 'tease'));
          return;
        }
        
        if (isProductPage()) {
          var ptype = currentProductType();
          var pdpHost = document.querySelector('product-form') || document.querySelector('.product-form');
          if (!pdpHost) return;
          // WELCOME100 first-order cue on ALL PDPs (oversized + supima + others)
          if (!document.querySelector('.su-welcome-cue')) {
            var suWAll = document.createElement('div');
            suWAll.className = 'su-welcome-cue';
            suWAll.innerHTML = '💡 First order? <strong>₹100 off</strong> with code <strong>WELCOME100</strong>';
            var _bmw2=(document.querySelector('.product-form__buttons')?getComputedStyle(document.querySelector('.product-form__buttons')).maxWidth:'');
            suWAll.style.cssText = 'display:block;margin:14px 0;padding:12px 16px;background:#F2EEE5;border:1px dashed #6B6B6B;border-radius:6px;font-size:14px;font-weight:600;text-align:center;color:#0F0F12;box-sizing:border-box;'+((_bmw2&&_bmw2!=='none')?'max-width:'+_bmw2+';':'');
            pdpHost.insertAdjacentElement('afterend', suWAll);
          }
          // Combo nudge is Spirit-Animal (Oversized) only
          if (ptype !== OVERSIZED_TYPE) return;
          
          if (oversizedQty === 0) {
            pdpHost.insertAdjacentElement('afterend', pill('💡 ' + SAVINGS_LINE + ' Combo applies automatically when 2 Spirit Animal tees are in cart.', 'neutral'));
          } else if (oversizedQty === 1) {
            pdpHost.insertAdjacentElement('afterend', pill('✨ Adding this unlocks ' + SAVINGS_LINE, 'tease'));
          } else {
            pdpHost.insertAdjacentElement('afterend', pill('🎉 Combo already unlocked — ₹99 off applied in your cart.', 'win'));
          }
          var suCombo = pdpHost.nextElementSibling;
          if (suCombo && suCombo.classList && suCombo.classList.contains('su-combo-nudge') && !document.querySelector('.su-welcome-cue')) {
            var suW = document.createElement('div');
            suW.className = 'su-welcome-cue su-pdp-cue su-pdp-cue--offer';
            suW.innerHTML = 'First order? <strong>₹100 off</strong> with code <strong>WELCOME100</strong>';
            suW.style.cssText = 'display:block;margin:14px 0 0;padding:12px 16px;text-align:center;border-radius:6px;';
            suCombo.insertAdjacentElement('beforebegin', suW);
          }
        }
      })
      .catch(function(){});
  }
  
  function setup() {
    renderNudge();
    document.addEventListener('cart:updated', renderNudge);
    var origFetch = window.fetch;
    window.fetch = function(){
      var p = origFetch.apply(this, arguments);
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
        p.then(function(){ setTimeout(renderNudge, 250); });
      }
      return p;
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();




// SU_NEW_BADGE — wrap "· NEW" suffix in nav links with a styled pill
(function(){
  if (typeof document === 'undefined') return;
  function applyBadges() {
    var links = document.querySelectorAll('header a, nav a, .header__inline-menu a, .header__submenu a, .menu-drawer a');
    links.forEach(function(a){
      if (a.dataset.suNewProcessed) return;
      var txt = a.textContent.trim();
      // Use [\s\S] to match across newlines (link text has leading/trailing whitespace)
      var match = txt.match(/^([\s\S]+?)\s*[·•|\-]?\s*NEW$/i);
      if (match && match[1].trim().length > 0) {
        var base = match[1].trim();
        a.innerHTML = base + ' <span class="su-new-badge su-new-badge--pulse">NEW</span>';
        a.dataset.suNewProcessed = '1';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBadges);
  } else {
    applyBadges();
  }
  // Re-run after a tick to catch dynamic content
  setTimeout(applyBadges, 500);
  document.addEventListener('click', function(e){
    if (e.target.closest('summary, [aria-controls*="menu"], header-drawer')) {
      setTimeout(applyBadges, 80);
    }
  }, true);
  // Also expose for manual debug
  window.__SU_APPLY_BADGES = applyBadges;
})();


// SU_WHATSAPP_FAB — sticky floating WhatsApp button site-wide
(function(){
  if (typeof document === 'undefined') return;
  function mount() {
    if (document.querySelector('.su-wa-fab')) return;
    var a = document.createElement('a');
    a.className = 'su-wa-fab';
    a.href = 'https://wa.me/919582474740?text=Hi%20StyleUp%2C';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat on WhatsApp');
    a.innerHTML = '<svg width="28" height="28" viewBox="0 0 32 32" fill="white"><path d="M16 0C7.2 0 0 7.2 0 16c0 2.8.7 5.5 2.1 7.9L0 32l8.4-2.2c2.3 1.3 4.9 1.9 7.6 1.9 8.8 0 16-7.2 16-16S24.8 0 16 0zm0 29.3c-2.4 0-4.8-.6-6.9-1.9l-.5-.3-5 1.3 1.3-4.9-.3-.5C3.2 20.8 2.7 18.4 2.7 16 2.7 8.7 8.7 2.7 16 2.7S29.3 8.7 29.3 16 23.3 29.3 16 29.3zm7.3-10c-.4-.2-2.4-1.2-2.7-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.4-2.2-2.8-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7.2-.2.3-.4.4-.6.1-.3 0-.5-.1-.7-.1-.2-.9-2.1-1.2-2.9-.3-.8-.7-.7-.9-.7h-.8c-.3 0-.7.1-1.1.5-.4.4-1.5 1.4-1.5 3.5s1.5 4 1.7 4.3c.2.3 3 4.6 7.2 6.4 1 .4 1.8.7 2.4.9.6.1 1.2.1 1.7-.1.5-.1 1.6-.7 1.8-1.3.2-.6.2-1.2.2-1.3-.1-.1-.4-.2-.7-.4z"/></svg>';
    document.body.appendChild(a);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();


// SU_MADE_IN_INDIA — inject an honest 'Made in India' badge on PDPs, EXCEPT the Supima line (Sutra/Zen render .su-supima)
(function(){
  if (typeof document === 'undefined') return;
  function mountMii(){
    if (location.pathname.indexOf('/products/') !== 0) return;
    if (document.querySelector('.su-mii-badge')) return;
    if (document.querySelector('.su-supima')) return; // Supima line: no Made-in-India badge
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var anchor = info.querySelector('.product__title') || info.querySelector('h1') || info.querySelector('.su-pdp-rating');
    var b = document.createElement('div');
    b.className = 'su-mii-badge';
    b.textContent = '🇮🇳 Made in India';
    b.style.cssText = 'display:inline-flex;align-items:center;gap:6px;margin:10px 0 2px;padding:5px 12px;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#0F0F12;background:#F2EEE5;border:1px solid rgba(15,15,18,.18);border-radius:999px;line-height:1;';
    if (anchor) anchor.insertAdjacentElement('afterend', b);
    else info.insertAdjacentElement('afterbegin', b);
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', mountMii);
  else mountMii();
  setTimeout(mountMii, 500); setTimeout(mountMii, 1500); setTimeout(mountMii, 3000);
})();

/* SU-QV-THUMBS */
(function(){
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('.su-qv__thumb');
    if(!t) return;
    var src = t.getAttribute('data-su-qv-src'); if(!src) return;
    var media = t.closest('.su-qv__media'); if(!media) return;
    var main = media.querySelector('.su-qv__main'); if(main) main.src = src;
    media.querySelectorAll('.su-qv__thumb.is-active').forEach(function(x){x.classList.remove('is-active');});
    t.classList.add('is-active');
  });
})();


/* SU-QV-PLACE */
(function(){
  function place(){
    document.querySelectorAll('.card-wrapper').forEach(function(cw){
      var qa = cw.querySelector('.quick-add');
      var inner = cw.querySelector('.card__inner');
      if(!qa || !inner) return;
      if(qa.parentElement !== inner) inner.appendChild(qa);
    });
  }
  if(document.readyState!=='loading') place(); else document.addEventListener('DOMContentLoaded', place);
  window.addEventListener('load', place);
  window.addEventListener('resize', function(){ clearTimeout(window.__suQvT); window.__suQvT=setTimeout(place,200); });
})();


/* SU-QV-CLICK */
(function(){
  function within(e, r){ return e.clientX>=r.left-3 && e.clientX<=r.right+3 && e.clientY>=r.top-3 && e.clientY<=r.bottom+3; }
  document.addEventListener('click', function(e){
    var cw = e.target.closest && e.target.closest('.card-wrapper');
    if(!cw) return;
    var btn = cw.querySelector('modal-opener .quick-add__submit');
    if(!btn) return;
    var r = btn.getBoundingClientRect();
    if(r.width===0) return;
    if(within(e, r)){
      e.preventDefault();
      e.stopPropagation();
      var opener = btn.closest('modal-opener');
      var modal = opener && document.querySelector(opener.getAttribute('data-modal'));
      if(modal && typeof modal.show === 'function'){ modal.show(btn); }
    }
  }, true);
})();


/* SU-QV-PIN */
(function(){
  var MM=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  document.addEventListener('click', function(e){
    var b=e.target.closest && e.target.closest('.su-qv__pinbtn');
    if(!b) return;
    var wrap=b.closest('.su-qv__delivery');
    var inp=wrap.querySelector('.su-qv__pininput');
    var out=wrap.querySelector('.su-qv__pinout');
    var pin=(inp.value||'').replace(/\D/g,'');
    if(pin.length!==6){ out.style.color='#c0392b'; out.textContent='Enter a valid 6-digit pincode'; return; }
    var add=[3,3,3,3,3,4,4];
    var d=new Date(); d.setDate(d.getDate()+add[d.getDay()]);
    var by=('0'+d.getDate()).slice(-2)+'-'+MM[d.getMonth()];
    out.style.color='#1a7f37';
    out.textContent='\uD83D\uDE9A Delivery by '+by+' \u00b7 Free shipping \u00b7 COD available';
    try{localStorage.setItem('su_pin',pin);}catch(_e){}
  });
})();


/* SU-QV-COLORFILTER */
(function(){
  function filt(root){ if(!root) return; var cfs=root.querySelector('fieldset'); if(!cfs) return; var chk=cfs.querySelector('input:checked'); var sel=chk?(chk.value||'').toLowerCase():null; if(!sel) return; var allColors=[]; cfs.querySelectorAll('input').forEach(function(i){ var v=(i.value||'').toLowerCase(); if(v) allColors.push(v); }); var imgs=root.querySelectorAll('.su-qv__g'); var any=false; imgs.forEach(function(im){ var a=(im.getAttribute('data-su-alt')||''); var isThis=a.indexOf('\u2014 '+sel)>=0; var hasColor=allColors.some(function(c){ return a.indexOf('\u2014 '+c)>=0; }); var meta=a+' '+(im.getAttribute('data-su-src')||'')+' '+(im.innerHTML||''); var isLifestyle=/street-style|streetwear|worn in|lifestyle|editorial/i.test(meta); var show=isLifestyle || isThis || !hasColor; im.style.display=show?'':'none'; if(show)any=true; }); if(!any) imgs.forEach(function(im){ im.style.display=''; }); }
  document.addEventListener('change', function(e){ var r=e.target.closest && e.target.closest('.su-qv'); if(r) setTimeout(function(){ filt(r); },0); }, true);
  var mo=new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ if(muts[i].addedNodes && muts[i].addedNodes.length){ var qv=document.querySelector('quick-add-modal[open] .su-qv'); if(qv){ filt(qv); break; } } } });
  if(document.body) mo.observe(document.body,{subtree:true,childList:true});
})();


/* SU-SHOP-ALL */
(function(){
  function add(){
    document.querySelectorAll('.collection__title').forEach(function(tw){
      if(tw.querySelector('.su-shop-all')) return;
      var sec=tw.closest('.shopify-section')||tw.closest('.collection');
      var va=sec&&sec.querySelector('.collection__view-all a, a.link.underlined-link');
      var href=va?va.getAttribute('href'):null;
      if(!href) return;
      var a=document.createElement('a');
      a.className='su-shop-all'; a.href=href; a.textContent='SHOP ALL';
      tw.appendChild(a);
    });
  }
  if(document.readyState!=='loading') add(); else document.addEventListener('DOMContentLoaded', add);
  window.addEventListener('load', add);
})();


/* SU-QV-LIGHTBOX */
(function(){
  var lb=null, scale=1;
  function el(tag,cls){var e=document.createElement(tag); if(cls)e.className=cls; return e;}
  function build(){
    if(lb)return;
    lb=el('div','su-qvlb');
    var close=el('button','su-qvlb__close'); close.setAttribute('aria-label','Close'); close.textContent='\u00d7';
    var zoom=el('div','su-qvlb__zoom');
    var zin=el('button','su-qvlb__zin'); zin.setAttribute('aria-label','Zoom in'); zin.textContent='+';
    var zout=el('button','su-qvlb__zout'); zout.setAttribute('aria-label','Zoom out'); zout.textContent='\u2212';
    zoom.appendChild(zin); zoom.appendChild(zout);
    var stage=el('div','su-qvlb__stage'); var img=el('img','su-qvlb__img'); img.alt=''; stage.appendChild(img);
    var thumbs=el('div','su-qvlb__thumbs');
    lb.appendChild(close); lb.appendChild(zoom); lb.appendChild(stage); lb.appendChild(thumbs);
    document.body.appendChild(lb);
    close.addEventListener('click', closeLb);
    lb.addEventListener('click', function(e){ if(e.target===lb || e.target===stage) closeLb(); });
    zin.addEventListener('click', function(e){ e.stopPropagation(); setScale(scale+0.4); });
    zout.addEventListener('click', function(e){ e.stopPropagation(); setScale(scale-0.4); });
    thumbs.addEventListener('click', function(e){ var b=e.target.closest('button[data-full]'); if(b) showImg(b.getAttribute('data-full')); });
  }
  function setScale(s){ scale=Math.min(3,Math.max(1,s)); lb.querySelector('.su-qvlb__img').style.transform='scale('+scale+')'; }
  function showImg(full){ scale=1; var img=lb.querySelector('.su-qvlb__img'); img.style.transform='scale(1)'; img.src=full; lb.querySelectorAll('.su-qvlb__thumbs button').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-full')===full); }); }
  function openLb(items, currentFull){
    build();
    var th=lb.querySelector('.su-qvlb__thumbs'); th.innerHTML='';
    items.forEach(function(it){ var b=el('button'); b.setAttribute('data-full',it.full); var im=el('img'); im.src=it.thumb; im.alt=''; b.appendChild(im); th.appendChild(b); });
    showImg(currentFull);
    lb.classList.add('is-open'); document.documentElement.style.overflow='hidden';
  }
  function closeLb(){ if(lb){ lb.classList.remove('is-open'); document.documentElement.style.overflow=''; } }
  document.addEventListener('click', function(e){
    if(!window.matchMedia('(max-width:749px)').matches) return;
    var g=e.target.closest('.su-qv__g'); if(!g) return;
    e.preventDefault(); e.stopPropagation();
    var gallery=g.closest('.su-qv__gallery'); if(!gallery) return;
    var imgs=[].slice.call(gallery.querySelectorAll('.su-qv__g')).filter(function(x){return getComputedStyle(x).display!=='none';});
    var items=imgs.map(function(x){return {thumb:x.getAttribute('src'), full:x.getAttribute('data-su-full')||x.getAttribute('src')};});
    openLb(items, g.getAttribute('data-su-full')||g.getAttribute('src'));
  }, true);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeLb(); });
})();


/* SU-CART-DELIVER */
(function(){
  var MM=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function eta(){var add=[3,3,3,3,3,4,4];var d=new Date();d.setDate(d.getDate()+add[d.getDay()]);return ('0'+d.getDate()).slice(-2)+'-'+MM[d.getMonth()];}
  function getPin(){try{return (localStorage.getItem('su_pin')||'').replace(/\D/g,'');}catch(e){return '';}}
  var PIN='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>';
  function render(force){
    var bar=document.querySelector('[data-su-deliver]'); if(!bar) return;
    if(!force && bar.querySelector('.su-cart-deliver__inp')) return;
    var pin=getPin(); var ok=/^\d{6}$/.test(pin);
    var state=ok?('p'+pin):'none';
    if(bar.getAttribute('data-su-state')===state && bar.children.length) return;
    bar.setAttribute('data-su-state',state);
    if(ok){
      bar.innerHTML='<span class="su-cart-deliver__l">'+PIN+' Deliver to <strong>'+pin+'</strong> · by '+eta()+'</span><button type="button" class="su-cart-deliver__btn" data-su-pin-change>CHANGE</button>';
    } else {
      bar.innerHTML='<span class="su-cart-deliver__l">'+PIN+' Add a delivery pincode</span><button type="button" class="su-cart-deliver__btn" data-su-pin-change>CHECK</button>';
    }
  }
  function editor(){
    var bar=document.querySelector('[data-su-deliver]'); if(!bar) return;
    bar.setAttribute('data-su-state','edit');
    bar.innerHTML='<input type="tel" inputmode="numeric" maxlength="6" class="su-cart-deliver__inp" placeholder="Enter 6-digit pincode" value="'+getPin()+'"><button type="button" class="su-cart-deliver__btn" data-su-pin-save>Check</button>';
    var i=bar.querySelector('input'); if(i){i.focus();}
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-su-pin-change]')){e.preventDefault();editor();return;}
    var sv=e.target.closest('[data-su-pin-save]');
    if(sv){e.preventDefault();var bar=document.querySelector('[data-su-deliver]');var inp=bar.querySelector('input');var x=(inp.value||'').replace(/\D/g,'');if(x.length!==6){inp.style.borderColor='#c0392b';inp.focus();return;}try{localStorage.setItem('su_pin',x);}catch(_e){}render(true);return;}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Enter'){var a=document.activeElement;if(a&&a.classList&&a.classList.contains('su-cart-deliver__inp')){var sv=document.querySelector('[data-su-pin-save]');if(sv){e.preventDefault();sv.click();}}}});
  window.suRenderDeliver=function(){render();};
  function boot(){
    render();
    var cd=document.querySelector('cart-drawer');
    if(cd){ new MutationObserver(function(){render();}).observe(cd,{childList:true,subtree:true,attributes:true,attributeFilter:['class']}); }
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();

/* SU-CART-SIZE */
(function(){
  function applyHTML(html, sel){
    if(!html) return;
    var d=new DOMParser().parseFromString(html,'text/html');
    var nw=d.querySelector(sel); var cur=document.querySelector(sel);
    if(nw&&cur) cur.innerHTML=nw.innerHTML;
  }
  function refresh(state){
    try{
      applyHTML(state['cart-drawer'], '.drawer__inner');
      var b=state['cart-icon-bubble'];
      if(b){var d2=new DOMParser().parseFromString(b,'text/html');var nb=d2.querySelector('.shopify-section')||d2.body.firstElementChild;var cb=document.querySelector('#cart-icon-bubble');if(nb&&cb)cb.innerHTML=nb.innerHTML;}
    }catch(e){}
    var cd=document.querySelector('cart-drawer');if(cd){cd.classList.add('active','animate');document.body.classList.add('overflow-hidden');}
    if(window.suRenderDeliver){try{window.suRenderDeliver();}catch(e){}}
    if(window.suPlaceCard){try{window.suPlaceCard();}catch(e){}}
  }
  document.addEventListener('change',function(e){
    var sel=e.target.closest('.su-size-select'); if(!sel) return;
    e.stopPropagation();
    var newId=Number(sel.value), key=sel.getAttribute('data-line'), qty=Number(sel.getAttribute('data-qty'))||1;
    sel.style.opacity='.5'; sel.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:newId,quantity:qty}]})});})
      .then(function(){return fetch('/?sections=cart-drawer,cart-icon-bubble');})
      .then(function(r){return r.json();})
      .then(function(s){refresh(s);})
      .catch(function(){location.reload();});
  }, true);
})();

/* SU-CART-CARD */
(function(){
  var MM=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function etaLabel(){var add=[3,3,3,3,3,4,4];var d=new Date();d.setDate(d.getDate()+add[d.getDay()]);return ('0'+d.getDate()).slice(-2)+' '+MM[d.getMonth()];}
  var TRUCK='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.8"/><circle cx="17.5" cy="17" r="1.8"/></svg>';
  function place(){
    document.querySelectorAll('cart-drawer .cart-item').forEach(function(ci){
      var row=ci.querySelector('.su-size-row');
      var qtyTd=ci.querySelector('.cart-item__quantity');
      if(row&&qtyTd&&!row.querySelector('.cart-item__quantity')){ row.appendChild(qtyTd); }
      var rm=ci.querySelector('cart-remove-button');
      if(rm&&rm.parentNode!==ci){ rm.classList.add('su-card-remove'); ci.appendChild(rm); }
      var det=ci.querySelector('.cart-item__details');
      if(det&&!det.querySelector('.su-card-eta')){
        var e=document.createElement('div'); e.className='su-card-eta';
        e.innerHTML=TRUCK+' Delivery by <strong>'+etaLabel()+'</strong>';
        det.appendChild(e);
      }
    });
  }
  window.suPlaceCard=place;
  if(document.readyState!=='loading')place();else document.addEventListener('DOMContentLoaded',place);
  var cd=document.querySelector('cart-drawer');
  if(cd){ new MutationObserver(function(){place();}).observe(cd,{childList:true,subtree:true}); }
})();


/* SU-CART-OFFERS */
(function(){
  document.addEventListener('click',function(e){
    var cp=e.target.closest('[data-su-copy]');
    if(cp){ e.preventDefault(); try{ if(navigator.clipboard){navigator.clipboard.writeText(cp.getAttribute('data-su-copy'));} }catch(_e){} cp.textContent='Copied ✓'; return; }
    var co=e.target.closest('#CartDrawer-Checkout');
    if(co){ e.preventDefault(); window.location.href='/discount/WELCOME100?redirect=/checkout'; }
  });
})();


/* SU-CART-QTY */
(function(){
  function apply(){
    document.querySelectorAll('cart-drawer .cart-item .quantity__input').forEach(function(inp){
      inp.setAttribute('min','0'); inp.setAttribute('max','5'); inp.setAttribute('data-min','0');
      if(inp.hasAttribute('data-max')) inp.setAttribute('data-max','5');
    });
  }
  window.suApplyQty=apply;
  document.addEventListener('change',function(e){
    var inp=e.target.closest && e.target.closest('cart-drawer .cart-item .quantity__input'); if(!inp) return;
    var v=parseInt(inp.value,10);
    if(isNaN(v)||v<0){ inp.value=0; } else if(v>5){ inp.value=5; }
  }, true);
  function boot(){ apply(); var cd=document.querySelector('cart-drawer'); if(cd){ new MutationObserver(apply).observe(cd,{childList:true,subtree:true}); } }
  if(document.readyState!=='loading')boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
